module.exports = __webpack_public_path__ + "assets/images/92cb767dd88bc1fa915a794d80d9f1aa.png";